import { useParams, useNavigate } from 'react-router-dom';
import { TimelineContent } from '../components/TimelineContent';
import { useFeatureFlag } from '@/hooks/featureFlags';
import { PageHeader } from '@/components/layout/PageHeader';

export function TimelineView() {
  const { clienteId } = useParams<{ clienteId: string }>();
  const navigate = useNavigate();
  const timelineEnabled = useFeatureFlag('funil.timeline.view');

  if (!clienteId) {
    return (
      <>
        <PageHeader title="Jornada do Cliente" subtitle="Vendas" onBack={() => navigate('/vendas')} />
        <div className="flex-1 bg-[#f8fafc] dark:bg-[#141414] transition-colors duration-300">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="rounded-[24px] bg-white/60 dark:bg-zinc-950/60 backdrop-blur-lg border border-[rgba(15,118,110,0.08)] dark:border-white/5 p-8 text-center">
              <p className="text-gray-600 dark:text-gray-400">Cliente não encontrado</p>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (!timelineEnabled) {
    return (
      <>
        <PageHeader title="Jornada do Cliente" subtitle="Vendas" onBack={() => navigate('/vendas')} />
        <div className="flex-1 bg-[#f8fafc] dark:bg-[#141414] transition-colors duration-300">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="rounded-[24px] bg-white/60 dark:bg-zinc-950/60 backdrop-blur-lg border border-[rgba(15,118,110,0.08)] dark:border-white/5 p-8 text-center">
              <p className="text-gray-600 dark:text-gray-400">Timeline ainda não está disponível nesta versão.</p>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <PageHeader title="Jornada do Cliente" subtitle="Vendas" onBack={() => navigate('/vendas')} />
      <div className="flex-1 bg-[#f8fafc] dark:bg-[#141414] transition-colors duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <TimelineContent clienteId={clienteId} />
        </div>
      </div>
    </>
  );
}

export default TimelineView;
